(() => {
  const observedTracks = new WeakSet();
  const linkColour = 'rgb(82, 133, 103)';

  function updateArrows(component) {
    const track = component.querySelector(':scope > .slider');
    if (!track || !component.closest('quick-add-modal')) return;

    if (component.getBoundingClientRect().width < 1) return;

    component.classList.add('ph-qa-measuring');
    const hasOverflow = track.scrollWidth > track.clientWidth + 2;
    component.classList.remove('ph-qa-measuring');

    component.classList.toggle('ph-qa-has-overflow', hasOverflow);
    component.classList.toggle('ph-qa-no-overflow', !hasOverflow);
  }

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const component = entry.target.parentElement;
      if (component?.matches('slider-component')) updateArrows(component);
    }
  });

  function updateViewProductLink(modal) {
    const candidates = modal.querySelectorAll('a, button, [role="link"]');

    for (const candidate of candidates) {
      const label = [
        candidate.textContent,
        candidate.getAttribute('aria-label'),
        candidate.getAttribute('title')
      ].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();

      if (label.length > 150) continue;

      const compactLabel = label.replace(/[^a-z0-9]/gi, '').toLowerCase();
      const className = typeof candidate.className === 'string'
        ? candidate.className.toLowerCase()
        : '';

      const isProductLink =
        /view(?:the|full)?(?:product|details|more)/.test(compactLabel) ||
        /(?:view[-_]?product|view[-_]?full[-_]?details|product[-_]?view[-_]?details)/.test(className);

      if (!isProductLink) continue;

      candidate.classList.add('ph-qa-view-product');

      for (const element of [candidate, ...candidate.querySelectorAll('*')]) {
        element.style.setProperty('text-transform', 'uppercase', 'important');
      }
    }
  }

  function initModal(modal) {
    for (const component of modal.querySelectorAll('slider-component')) {
      const track = component.querySelector(':scope > .slider');
      if (!track) continue;

      if (!observedTracks.has(track)) {
        observedTracks.add(track);
        resizeObserver.observe(track);
        track.addEventListener('load', () => updateArrows(component), true);
      }
      updateArrows(component);
    }

    updateViewProductLink(modal);
  }

  function start() {
    document.querySelectorAll('quick-add-modal').forEach(initModal);

    const observer = new MutationObserver((mutations) => {
      const affected = new Set();
      for (const mutation of mutations) {
        const target = mutation.target;
        const owner = target.nodeType === 1
          ? target.closest('quick-add-modal')
          : target.parentElement?.closest('quick-add-modal');
        if (owner) affected.add(owner);

        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('quick-add-modal')) affected.add(node);
          node.querySelectorAll('quick-add-modal').forEach((modal) => affected.add(modal));
        }
      }
      affected.forEach(initModal);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
